import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-42">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50" onClick={onClose} data-id="element-43" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} className="fixed inset-4 md:inset-auto md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-2xl md:max-h-[80vh] bg-navy-800 border border-slate-700/50 rounded-2xl shadow-2xl z-50 flex flex-col overflow-hidden" data-id="element-44">
            <div className="flex items-center justify-between p-5 border-b border-slate-700/40" data-id="element-45">
              <h3 className="font-display text-xl font-bold text-white" data-id="element-46">
                {title}
              </h3>
              <button onClick={onClose} className="w-9 h-9 rounded-lg bg-navy-700 flex items-center justify-center text-slate-400 hover:text-white hover:bg-navy-600 transition-colors" aria-label="Cerrar" data-id="element-47">
                <XIcon className="w-5 h-5" data-id="element-48" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-5 md:p-6" data-id="element-49">
              <div className="text-slate-300 font-body text-sm leading-relaxed space-y-4" data-id="element-50">
                {children}
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}
export function FooterSection() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer id="footer" className="w-full bg-navy-900 border-t border-slate-800/50" data-id="element-51">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 py-10" data-id="element-52">
          <div className="text-center" data-id="element-53">
            <p className="font-display text-lg font-bold text-gold-400 mb-2" data-id="element-54">
              Plan Retiro
            </p>
            <p className="text-slate-500 font-body text-xs leading-relaxed max-w-lg mx-auto" data-id="element-55">
              Este material es educativo y no constituye asesoría financiera
              personalizada. Toda inversión conlleva riesgos. Los resultados
              pasados no garantizan resultados futuros. Consulta con un asesor
              financiero antes de tomar decisiones de inversión.
            </p>

            <div className="mt-5 flex items-center justify-center gap-4" data-id="element-56">
              <button onClick={() => setPrivacyOpen(true)} className="text-slate-500 hover:text-gold-400 font-body text-xs underline underline-offset-2 transition-colors cursor-pointer" data-id="element-57">
                Política de Privacidad
              </button>
              <span className="text-slate-700 text-xs" data-id="element-58">|</span>
              <button onClick={() => setTermsOpen(true)} className="text-slate-500 hover:text-gold-400 font-body text-xs underline underline-offset-2 transition-colors cursor-pointer" data-id="element-59">
                Términos y Condiciones
              </button>
            </div>

            <p className="mt-4 text-slate-600 font-body text-xs" data-id="element-60">
              © {new Date().getFullYear()} Plan Retiro. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-61">
        <p data-id="element-62">
          <strong className="text-white" data-id="element-63">1. Información que recopilamos</strong>
          <br data-id="element-64" />
          Recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, dirección de correo electrónico y datos de pago. No
          almacenamos información de tarjetas de crédito directamente; los pagos
          son procesados de forma segura por nuestro proveedor de pagos.
        </p>
        <p data-id="element-65">
          <strong className="text-white" data-id="element-66">2. Uso de la información</strong>
          <br data-id="element-67" />
          Tu información personal se utiliza exclusivamente para: procesar tu
          pedido, enviarte el producto digital adquirido, y comunicarte
          actualizaciones importantes relacionadas con tu compra.
        </p>
        <p data-id="element-68">
          <strong className="text-white" data-id="element-69">3. Protección de datos</strong>
          <br data-id="element-70" />
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción.
        </p>
        <p data-id="element-71">
          <strong className="text-white" data-id="element-72">4. Compartir información</strong>
          <br data-id="element-73" />
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. Esto no incluye terceros de confianza que nos asisten en la
          operación de nuestro sitio web o en la conducción de nuestro negocio,
          siempre que dichas partes acuerden mantener esta información
          confidencial.
        </p>
        <p data-id="element-74">
          <strong className="text-white" data-id="element-75">5. Cookies</strong>
          <br data-id="element-76" />
          Nuestro sitio puede utilizar cookies para mejorar la experiencia del
          usuario. Puedes configurar tu navegador para rechazar cookies, aunque
          esto podría afectar algunas funcionalidades del sitio.
        </p>
        <p data-id="element-77">
          <strong className="text-white" data-id="element-78">6. Tus derechos</strong>
          <br data-id="element-79" />
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. Para ejercer estos derechos, puedes
          contactarnos a través de los canales disponibles.
        </p>
      </LegalModal>

      {/* Terms Modal */}
      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-80">
        <p data-id="element-81">
          <strong className="text-white" data-id="element-82">1. Producto digital</strong>
          <br data-id="element-83" />
          Plan Retiro es un producto digital educativo. Al realizar tu compra,
          recibirás acceso inmediato al material en formato digital. Dado que se
          trata de un producto digital de acceso inmediato, no se aceptan
          devoluciones una vez entregado el contenido.
        </p>
        <p data-id="element-84">
          <strong className="text-white" data-id="element-85">2. Naturaleza educativa</strong>
          <br data-id="element-86" />
          Todo el contenido proporcionado en Plan Retiro es de carácter
          estrictamente educativo e informativo. No constituye asesoría
          financiera, de inversión, legal o fiscal personalizada. Las decisiones
          de inversión son responsabilidad exclusiva del usuario.
        </p>
        <p data-id="element-87">
          <strong className="text-white" data-id="element-88">3. Riesgos de inversión</strong>
          <br data-id="element-89" />
          Toda inversión en mercados financieros conlleva riesgos, incluyendo la
          posible pérdida del capital invertido. Los resultados pasados no
          garantizan resultados futuros. El usuario debe evaluar su propia
          tolerancia al riesgo antes de invertir.
        </p>
        <p data-id="element-90">
          <strong className="text-white" data-id="element-91">4. Propiedad intelectual</strong>
          <br data-id="element-92" />
          Todo el contenido de Plan Retiro está protegido por derechos de autor.
          Queda prohibida la reproducción, distribución o reventa del material
          sin autorización expresa por escrito.
        </p>
        <p data-id="element-93">
          <strong className="text-white" data-id="element-94">5. Uso personal</strong>
          <br data-id="element-95" />
          La licencia de uso es personal e intransferible. El comprador se
          compromete a no compartir, distribuir ni revender el contenido
          adquirido.
        </p>
        <p data-id="element-96">
          <strong className="text-white" data-id="element-97">
            6. Limitación de responsabilidad
          </strong>
          <br data-id="element-98" />
          Plan Retiro y sus creadores no serán responsables por pérdidas
          financieras derivadas de la aplicación de las estrategias enseñadas.
          El usuario asume toda la responsabilidad por sus decisiones de
          inversión.
        </p>
        <p data-id="element-99">
          <strong className="text-white" data-id="element-100">7. Modificaciones</strong>
          <br data-id="element-101" />
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor desde su publicación en
          el sitio web.
        </p>
      </LegalModal>
    </>;
}